module.exports = __webpack_public_path__ + "img/tn.fea87146.svg";